import { API, handleApiError } from "./utils";
import i18next from "../../i18n/i18n"
import { getSystemLanguage, languageMap } from "../../utils/languageUtils";



export const signUP = async (formData) => {
  try {
    const detectedLanguage = languageMap[i18next.language] || "English";
    const { data } = await API.post("/auth/signup",
      {
        "First_name": formData.First_name,
        "Last_name": formData.Last_name,
        "Company": formData.Company,
        "Position": formData.Position,
        "Email": formData.Email,
        "Password": formData.Password,
        "Phone": formData.Phone,
        "Company_ID": formData.Company_ID,
        "Role": "Analyst",
        "Username": formData.First_name + formData.Last_name,
        "Language": detectedLanguage,

      }
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const logIN = async (email, password) => {
  try {
    const { data } = await API.post("/auth/login", {
      Email: email,
      Password: password,
    });
    //check Language is set OR set English
    if (!data.user?.Language && data.user?.user_ID) {
      const systemLanguage = await getSystemLanguage();
      const backendLanguage = languageMap[systemLanguage] || "English";
      await API.put("/users/", null, {
        params: {
          site_id: data.user.Site_ID,
          first_name: data.user.First_name,
          last_name: data.user.Last_name,
          position: data.user.Position,
          email: data.user.Email,
          phone: data.user.Phone,
          role: data.user.Role,
          notifications: data.user.Notifications || 1,
          sms_notifications: data.user.SMS_Notifications || 0,
          email_notifications: data.user.Email_Notifications || 0,
          slack_notifications: data.user.Slack_Notifications || 0,
          language: backendLanguage,
        },
      });
    }

    return { error: null, data };
  } catch (error) {
    return handleApiError(error.response || error);
  }
};

export const logout = async () => {
  try {
    localStorage.removeItem("token");
    // The following API call can be removed if the backend doesn't need to do anything on logout
    const res = await API.post("/users/logout");
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const resetPassword = async (email) => {
  try {
    const res = await API.post("/auth/reset-password",null, {
      params: {
        email:email,
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getCurrentUser = async () => {
  try {
    const res = await API.get("/auth/getprofile");

    return { error: null, data: res.data };
  } catch (error) {
    const errorMessage = error.response?.data?.detail || error.message || 'Failed to fetch user profile';
    return { error: errorMessage, data: null };
  }
};